import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const SaudiReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Saudi Attestation:</h3>
        <p>
          Attestation for Saudi is needed for several reasons. It is a part of
          the evidence that shows that you are a truthful person & you are
          traveling to another country with genuine intentions. It ensures that
          your documents are authentic & you can be permitted in the country.
        </p>
        <p>
          It shall also build trust among the employee & employer or two
          businessmen if you are traveling for business or work. In the case of
          students, this procedure will give the college or university the
          assurance of your intention of pursuing the course from this
          organization.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time-span to get Saudi Certificate Attestation:</h3>
        <p>
          The total time-span required for Attestation for Saudi is based on
          several factors such as which country you need the attestation for, or
          the sort of documents, or the state you require it from. certificate
          attestation in Bangalore for Saudi.
        </p>
      </div>
    </div>
  );
};

export default SaudiReqMain;
